import axiosClient from "api/axiosClient"
import { CallAnalysisResult } from "type/callsAnalysis/callsAnalysis"

export const getCallAnalysis = async (
  uploadedFile: File,
): Promise<CallAnalysisResult> => {
  const { data: results } = await axiosClient.postForm("/calls_analysis", {
    file_object: uploadedFile,
  })
  return results
}
